import React from 'react';
import PropTypes from 'prop-types';

const ColData = ({ className, children }) => (
  <div className={className}>
    { children }
  </div>
);

ColData.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.element,
  ]),
  className: PropTypes.string.isRequired,
};

ColData.defaultProps = {
  children: null,
};

export default ColData;
